// extracted by mini-css-extract-plugin
module.exports = {"subTitle":"CustomColumn_subTitle__3jIaY","button":"CustomColumn_button__1IUzj"};